import { useStore } from '@nanostores/react'
import { use } from 'react'
import type { TrialReminderGroup } from '~/features/multi-page/lib/trial-reminder'
import { trialReminderGroupReady } from '~/loading'
import { $debugExperimentGroupOverride } from '~/store/debug'

/**
 * The arm the reminder page renders. Suspends until native has answered (or
 * failed, which is Control), so only the caller waits for the experiment. The
 * QA override from the DevTools panel wins over the resolved arm.
 */
export function useTrialReminderGroup(): TrialReminderGroup {
  const resolved = use(trialReminderGroupReady.promise)
  const override = useStore($debugExperimentGroupOverride)
  return override ?? resolved
}

/**
 * The arm right now, without waiting: Control until native has answered. For
 * the post-purchase flow, which must never suspend on the experiment. By the
 * plan page the arm has long resolved (the reminder page waited on it); a
 * purchase before that — a reload straight onto the plan page — has no lead
 * time chosen either, so Control is the right answer there too. The QA
 * override wins as it does on the page.
 */
export function currentTrialReminderGroup(): TrialReminderGroup {
  return (
    $debugExperimentGroupOverride.get() ??
    trialReminderGroupReady.resolved ??
    'Control'
  )
}
